import {
    CUSTOMER_PROSPECT_LIST,
    CUSTOMER_PROSPECT_CREATE,
    CUSTOMER_PROSPECT_UPDATE,
    CUSTOMER_PROSPECT_DELETE,
    CUSTOMER_PROSPECT_LIST_ACTIVE,
    CUSTOMER_PROSPECT_LIST_NAME,
} from '@/redux/actions/types';

const INIT_STATE = {
    list: {
        items: [],
        pagination: {
            currentPage: 1,
            total: 0,
            perPage: 30,
        },
    },

    active: {
        items: [],
        pagination: {
            currentPage: 1,
            total: 0,
            perPage: 20,
        },
    },

    names: {
        items: [],
    },

    detail: null,
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case CUSTOMER_PROSPECT_LIST:
            return {
                ...state,
                list: {
                    ...state.list,
                    items: action.payload?.data || [],
                    pagination: {
                        currentPage: parseInt(action.payload.current_page),
                        total: parseInt(action.payload.total),
                        perPage: parseInt(action.payload.per_page),
                    },
                },
            };

        case CUSTOMER_PROSPECT_LIST_NAME:
            return {
                ...state,
                names: {
                    ...state.names,
                    items: action.payload?.data || [],
                },
            };

        case CUSTOMER_PROSPECT_LIST_ACTIVE: {
            const merged = [...state.active.items, ...(action.payload?.data || [])];
            const unique = merged.filter(
                (v, i, arr) => arr.findIndex((v2) => v2.id === v.id) === i
            );

            return {
                ...state,
                active: {
                    ...state.active,
                    items: unique,
                    pagination: {
                        currentPage: parseInt(action.payload.current_page),
                        total: parseInt(action.payload.total),
                        perPage: parseInt(action.payload.per_page),
                    },
                },
            };
        }

        case CUSTOMER_PROSPECT_CREATE:
            return {
                ...state,
                list: {
                    ...state.list,
                    items: [action.payload, ...state.list.items],
                    pagination: {
                        ...state.list.pagination,
                        total: state.list.pagination.total + 1,
                    },
                },
            };

        case CUSTOMER_PROSPECT_UPDATE:
            return {
                ...state,
                list: {
                    ...state.list,
                    items: state.list.items.map((it) =>
                        it.id === action.payload.id ? action.payload : it
                    ),
                },
            };

        case CUSTOMER_PROSPECT_DELETE: {
            const ids = action.payload || [];
            return {
                ...state,
                list: {
                    ...state.list,
                    items: state.list.items.filter((it) => !ids.includes(it.id)),
                    pagination: {
                        ...state.list.pagination,
                        total: Math.max(0, state.list.pagination.total - ids.length),
                    },
                },
            };
        }

        default:
            return state;
    }
};